import httpService from './http.service';
import { API_URLS } from '../config/constants';

export interface AiBalance {
  openai: null;
  deepseek: { balance: number; currency: string } | null;
}

export const getAiBalance = () => httpService.get<AiBalance>(API_URLS.AI.BALANCE).then((r) => r.data);
